document.addEventListener('DOMContentLoaded', function () {
    const dropdownHead = document.querySelector('.dropdown-head');
    const dropdownMenu = document.querySelector('.banner-dropdown');
  
    if (dropdownHead && dropdownMenu) {
      dropdownHead.addEventListener('click', function () {
        dropdownMenu.classList.toggle('Opendropdonw');
      });
    }
});

function AddReadMore(limit = 500) {
    const elements = document.querySelectorAll('.add-read-more');
    elements.forEach(el => {
      if (el.classList.contains('read-more-processed')) return;

      const originalHTML = el.innerHTML;
      const originalText = el.textContent.trim();

      if (originalText.length <= limit) return;

      // Create a temporary element to clone and measure
      const temp = document.createElement('div');
      temp.innerHTML = originalHTML;
      let truncated = '';
      let charCount = 0;

      function truncateNode(node) {
        if (charCount >= limit) return;

        if (node.nodeType === Node.TEXT_NODE) {
          const text = node.textContent;
          const needed = limit - charCount;
          const sliced = text.slice(0, needed);
          charCount += sliced.length;
          truncated += sliced;
        } else if (node.nodeType === Node.ELEMENT_NODE) {
          truncated += `<${node.nodeName.toLowerCase()}${[...node.attributes].map(attr => ` ${attr.name}="${attr.value}"`).join('')}>`;
          node.childNodes.forEach(truncateNode);
          truncated += `</${node.nodeName.toLowerCase()}>`;
        }
      }

      temp.childNodes.forEach(truncateNode);

      el.innerHTML = `
        <div class="read-more-preview">${truncated}...</div>
        <div class="read-more-full" style="display: none;">${originalHTML}</div>
        <span class="rbtn read-more-toggle">Read more</span>
      `;

      el.classList.add('read-more-processed');
    });

    document.addEventListener('click', function (e) {
      if (e.target.classList.contains('read-more-toggle')) {
        const parent = e.target.closest('.add-read-more');
        const preview = parent.querySelector('.read-more-preview');
        const full = parent.querySelector('.read-more-full');
        const toggle = e.target;

        const isExpanded = full.style.display === 'block';
        full.style.display = isExpanded ? 'none' : 'block';
        preview.style.display = isExpanded ? 'block' : 'none';
        toggle.textContent = isExpanded ? 'Read more' : 'Read less';
      }
    });
}

document.addEventListener('DOMContentLoaded', () => {
    AddReadMore(480); // or another limit
});

document.addEventListener("DOMContentLoaded", function () {
  const questions = document.querySelectorAll(".faq-question");

  questions.forEach(function (question) {
    question.addEventListener("click", function () {
      const answer = this.nextElementSibling;

      // Close all answers
      document.querySelectorAll(".faq-answer").forEach(function (ans) {
        if (ans !== answer) {
          ans.style.display = "none";
        }
      });

      // Toggle the clicked one
      if (answer.style.display === "block") {
        answer.style.display = "none";
      } else {
        answer.style.display = "block";
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
    const form = document.getElementById('productsPerPageForm');
    const select = document.getElementById('products_per_page');

    // Function to get the current query parameter
    function getQueryParam(param) {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(param);
    }

    // Set the selected value from the query parameter
    const limit = getQueryParam('limit');
    if (limit) {
        select.value = limit;
    }

    // Submit the form when the dropdown value changes
    select.addEventListener('change', function () {
        form.submit();
    });
});

document.addEventListener('DOMContentLoaded', function () {

  // Check if we are on a collection page
  if (document.body.classList.contains('template-collection')) {
    
    // Example: Add a class to the first product on a collection page
    const firstProduct = document.querySelector('.product');
    if (firstProduct) {
      firstProduct.classList.add('highlighted-product');
    }
  }

  const urlPath = window.location.pathname;

  if (urlPath.includes('/collections/')) {
    const collectionHandle = urlPath.split('/collections/')[1];
    document.body.classList.add(collectionHandle);
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const closeFilterIcon = document.querySelector('.close-fillter-icon');
  if (closeFilterIcon) {
    closeFilterIcon.addEventListener('click', function () {
      document.querySelectorAll('.filter-group').forEach(group => {
        group.removeAttribute('open');
      });
    });
  }
});

document.addEventListener('click', function (e) {
  const summary = e.target.closest('.filter-group-summary');
  if (summary) {
    summary.classList.toggle('open-block');
  }
});

// hide empty label for mobile
  document.addEventListener('DOMContentLoaded', function () {
    if (window.innerWidth <= 767) {
      const labels = document.querySelectorAll('details#stone-name label');
      labels.forEach(label => {
        if (label.textContent.trim() === '') {
          const parentDiv = label.closest('div');
          if (parentDiv) parentDiv.style.display = 'none';
        }
      });
    }
  });

  // tab container
document.addEventListener('DOMContentLoaded', function () {
  const collectionBtn = document.querySelectorAll('#collection-additional-info .tab-btn');
  const collectionPane = document.querySelectorAll('#tab--content .tab-pane');

  if (collectionBtn.length && collectionPane.length) {
    collectionBtn.forEach(button => {
      button.addEventListener('click', () => {
        const target = button.getAttribute('data-tab');
        const targetPane = document.getElementById(target);

        const isActive = button.classList.contains('active');

        // Remove all active states
        collectionBtn.forEach(btn => btn.classList.remove('active'));
        collectionPane.forEach(content => content.classList.remove('active'));

        // If it was NOT active → activate it
        if (!isActive) {
          button.classList.add('active');
          targetPane.classList.add('active');
        }
        // If it WAS active → do nothing (it stays closed)
      });
    });
  }
});

//
document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("click", function (e) {
    const readMoreBtn = document.querySelector(".read-more-link");
    const readLessBtn = document.querySelector(".read-less-link");

    /* READ MORE CLICKED */
    if (e.target.closest(".read-more-link")) {
      document.querySelectorAll(".long-desc").forEach(desc => {
        desc.classList.add("active");
      });

      document.querySelectorAll(".short-desc").forEach(desc => {
        desc.classList.add("inactive");
      });

      if (readLessBtn) {
        readLessBtn.classList.add("active");
      }
    }

    /* READ LESS CLICKED */
    if (e.target.closest(".read-less-link")) {
      document.querySelectorAll(".long-desc").forEach(desc => {
        desc.classList.remove("active");
      });

      document.querySelectorAll(".short-desc").forEach(desc => {
        desc.classList.remove("inactive");
      });

      if (readLessBtn) {
        readLessBtn.classList.remove("active");
      }
    }
  });
});

/*
  -----------------------------------
  CREATE FILTER BLOCK
  -----------------------------------
  */

document.addEventListener("DOMContentLoaded", function () {

  /* -----------------------------------
     PRODUCT GRID REFERENCE
     ----------------------------------- */
  const productGrid =
    document.querySelector('#product-grid ul.product-grid') ||
    document.querySelector('ul.product-grid') ||
    document.querySelector('#product-grid');

  if (!productGrid) return;

  /*
    -----------------------------------
    CREATE "DID YOU KNOW" BLOCK
    -----------------------------------
    */

    function createDidYouKnowBlock() {

        const infoDiv = document.createElement('li');

        infoDiv.className = 'collection-info-block';

        infoDiv.innerHTML = `
            <div class="info-inner">

                <div class="customer-info-container"
                    style="background-image:url('https://cdn.shopify.com/s/files/1/0619/9708/8842/files/collection-background_6d969368-3a3d-49d0-b3f3-25d4c36fd805.png?v=1779951511')">

                    <div class="customer-info">

                        <div class="media">
                            <img src="https://cdn.shopify.com/s/files/1/0619/9708/8842/files/gem-collection.png?v=1779951675">
                        </div>

                        <div class="info">

                            <div class="info-heading">
                                Did you know?
                            </div>

                            <div class="info-sub">
                                Each gemstone is one of a kind. Every SKU is unique, carefully selected, and photographed as the actual piece, so the stone you choose is truly yours.
                            </div>

                        </div>

                    </div>

                </div>

            </div>
        `;

        infoDiv.style.gridColumn = '1 / -1';

        return infoDiv;
    }

  /* -----------------------------------
     INSERT BLOCKS
     ----------------------------------- */
  function insertBlocks() {

    productGrid.querySelectorAll('.collection-info-block, .mobile-filter-block')
      .forEach(el => el.remove());

    const products = productGrid.querySelectorAll('.grid__item');
    if (!products.length) return;

    const isMobile = window.innerWidth <= 600;

    /* DESKTOP */
    if (!isMobile) {
      const activeGrid = document.querySelector('.grid-view-mode .grid-mode.active');
      if (!activeGrid) return;
      let columns = parseInt(activeGrid.dataset.grid);
      columns = Math.max(1, Math.min(columns, 5));
      const insertAfter = columns * 2;
      const isFirstCollectionPage = location.pathname.startsWith('/collections/') && !new URLSearchParams(location.search).has('page');
      if (isFirstCollectionPage && products.length >= 2){
        if (products.length >= insertAfter) {
          products[insertAfter - 1].after(createDidYouKnowBlock());
        }
      }
      return;
    }

    /* MOBILE */
    const isFirstCollectionPage = location.pathname.startsWith('/collections/') && !new URLSearchParams(location.search).has('page');
    if (isFirstCollectionPage && products.length >= 2) products[1].after(createDidYouKnowBlock());
  }

  /* INIT */
  insertBlocks();

  /* RESIZE */
  window.addEventListener('resize', () => {
    clearTimeout(window.collectionResizeTimer);
    window.collectionResizeTimer = setTimeout(insertBlocks, 150);
  });

  /* GRID CHANGE */
  document.querySelectorAll('.grid-view-mode .grid-mode').forEach(btn => {
    btn.addEventListener('click', () => setTimeout(insertBlocks, 100));
  });

});